import Device, { DeviceModel } from 'types/models/device';

import { patchDeviceStatus } from './patch-device-status';

export const computeDevice = (device: Device) => {
  if (device.model !== DeviceModel.XTEND_TROUGH) {
    return device;
  }

  const patchedData = patchDeviceStatus({
    status: device.status,
    statusCause: device.statusCause,
    lastStatusDate: device.lastStatusDate,
    lastDataDate: device.lastDataDate
  });

  return {
    ...device,
    ...patchedData
  };
};
